import {formatRelative} from 'date-fns';

export const isSavedScenarioParent = (scenario) => !scenario?.parentId && !scenario?.snapshot;

export const normalizeScenarioCatalog = (data) => {
    const records = Array.isArray(data) ? data : data?.saved_scenarios || [];
    const byId = new Map();
    records.forEach((record) => {
        if (record?.scenarioId) byId.set(record.scenarioId, record);
    });
    // Rollup/legacy responses can nest version metadata instead of returning
    // the flat snapshot records provided by /saved-scenarios.
    records.forEach((parent) => (parent.children || []).forEach((child) => {
        const id = child.scenarioId || child.scenario_id;
        if (id && !byId.has(id)) byId.set(id, {
            scenarioId: id,
            parentId: parent.scenarioId,
            snapshot: true,
            name: child.name,
            datetime_created: child.datetime_created || child.created_date,
            datetime_modified: child.datetime_modified || child.modified_date || child.created_date,
        });
    }));
    const scenarios = [...byId.values()];
    const parents = scenarios.filter(isSavedScenarioParent).map((parent) => ({
        ...parent,
        versions: scenarios.filter((version) => version.parentId === parent.scenarioId),
    }));
    return {scenarios, parents, byId};
};

export const isCompleteSavedScenario = (record) => Boolean(
    record?.scenarioId && record.inputData && typeof record.inputData === 'object'
    && !Array.isArray(record.inputData)
);

export const mergeScenarioSummaryAndDetail = (summary, detail) => {
    if (!detail) return summary;
    const summaryTime = Date.parse(summary?.datetime_modified || summary?.datetime_created || '');
    const detailTime = Date.parse(detail.datetime_modified || detail.datetime_created || '');
    const merged = Number.isFinite(summaryTime) && Number.isFinite(detailTime) && summaryTime > detailTime
        ? {...detail, ...summary}
        : {...summary, ...detail};
    // Tab state comes from the validated lightweight catalog. Opening/closing
    // a tab does not necessarily change datetime_modified on the saved record.
    if (Object.prototype.hasOwnProperty.call(summary || {}, 'open')) merged.open = summary.open;
    return merged;
};

export const resolveScenarioAccount = ({currUser, availableAccounts = [], activeAccount}, override) => {
    const accountId = override || currUser?.customerId;
    const account = availableAccounts.find((item) => item.customerId === accountId)
        || (activeAccount?.customerId === accountId ? activeAccount : null);
    return {accountId, isRollup: (account?.accountType || (accountId === currUser?.customerId ? currUser?.accountType : undefined)) === 'rollup'};
};

export const getScenarioVersionLabel = (parent, version) => {
    const date = new Date(version.datetime_modified || version.datetime_created || '');
    const label = Number.isFinite(date.getTime()) ? formatRelative(date, new Date()) : version.name || 'Saved version';
    return `${parent.name || parent.scenarioName || parent.scenarioId} (${label})`;
};
